import { Settings } from '@lightningjs/sdk'
import FloVizbeeConverters from './FloVizbeeConverters'
import FloVizbeeHandlers from './FloVizbeeHandlers'

export enum VizbeeStopReasons {
  // Means the user started playback of another video from the mobile app while a video was already playing
  STOP_IMPLICIT = 'stop_implicit',
  // Means user pressed the STOP button on the mobile app
  STOP_BY_USER = 'stop_by_user',
  // Sent shortly after the STOP_IMPLICIT, means a new video from the mobile app is requested to initiate playback
  STOP_REASON_BEFORE_NEXT_VIDEO = 'stop_reason_before_next_video',
}

export class VizbeeReceiver {
  public readonly VIZBEE_APP_ID: string = Settings.get('app', 'env.APP_VIZBEE_ID', 'vzb0349023408')

  constructor() {
    this.listenToVizbeeSdkReady()
    this.initVizbee()
  }

  initVizbee() {
    const vizbeeScript = document.createElement('script')
    vizbeeScript.src = `https://sdk.claspws.tv/v7/vizbee.js?appid=${this.VIZBEE_APP_ID}`
    vizbeeScript.addEventListener('load', () =>
      console.info('Vizbee Receiver SDK loaded successfully'),
    )
    vizbeeScript.addEventListener('error', (e) =>
      console.error('There was an error loading the Vizbee Receiver SDK. Details:', e),
    )
    document.head.appendChild(vizbeeScript)
  }

  listenToVizbeeSdkReady() {
    // ensure that the app sets this handler on the window before loading the Vizbee SDK.
    window.addEventListener('VIZBEE_SDK_READY', () => {
      // initialize the Vizbee SmartTV SDK in your app
      this.setVizbeeSigninEventHandler()
      this.setVizbeeDeeplinkHandler()
      this.vzbInstance?.start(this.VIZBEE_APP_ID)
    })
  }

  setVizbeeDeeplinkHandler() {
    this.vzbInstance?.getAppAdapter()?.setDeeplinkHandler?.(FloVizbeeHandlers.deeplinkHandler)
  }

  setVizbeeSigninEventHandler() {
    this.vzbInstance
      ?.getAppAdapter()
      ?.setVizbeeSigninEventHandler?.(FloVizbeeHandlers.signInHandler)
  }

  createVizbeePlayerAdapter(playerElement) {
    return new vizbee.continuity.adapters.PlayerAdapter(
      vizbee.continuity.adapters.PlayerType.HTML,
      playerElement,
    )
  }

  setVizbeePlayerAdapter(vzbPlayerAdapter) {
    this.vzbInstance.setPlayerAdapter(vzbPlayerAdapter)
  }

  async updateVideoInfo(playerModel, currentTime, imgUrl, videoUrl) {
    let { videoInfo } = playerModel

    if (!videoInfo) {
      // An undefined videoInfo object means that playback was initiated from the the TV directly and not through the mobile app.
      // Hence we need to create a VideoInfo object so the mobile app knows what the TV is playing
      videoInfo = await FloVizbeeConverters.toVideoInfo(playerModel, currentTime, imgUrl, videoUrl)
    }

    const playerAdapter = this.vzbInstance.getPlayerAdapter()
    playerAdapter?.updateVideoInfo(videoInfo)
  }

  get vzbInstance() {
    return window.vizbee?.continuity?.ContinuityContext?.getInstance()
  }
}
